export const USUARIOS_PUEDEN_ELIMINAR = [
  "ricardo.perez@escotel.com.mx",
  "carlos.guzman@escotel.com.mx",
  "pat9000@hotmail.com",
];
